import NomenclatureModelRouterHook from "@/new/auth/nomenclature-model.router-hook";
import get_title from "@/router/module/get_title";

export default {
  path: "/content/catalog/:modelId/settings",
  name: "model-edit__settings",
  meta: {
    title: get_title("Модель | Основная информация"),
    forVisitors: true,
    requiresAuth: true
  },
  component: () => import("@/components/dialogs/catalog/model-edit-settings.vue"),
  beforeEnter: NomenclatureModelRouterHook("model.show-general"),
};
